import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import { fetchConToken } from 'helpers/fetch';
import { useTranslation } from "react-i18next";
import ListTable from 'components/table/ListTable';
import { getDataSession, validarExisteSucursalPrincipal } from 'views/Utils/Common';
import RenderButtons from 'components/table/RenderButtons';
import { useGlobalState } from 'resources/GlobalStateContext';

const List = ({ match, saludo, subtitulo }) => {
    const { path } = match;
    const { t } = useTranslation("common");
    const [erp, setERP] = useState('');
    const [tienda] = useState(getDataSession('tienda'));
    const { setGlobalTitulo } = useGlobalState();
    const [actualizarTabla, setActualizarTabla] = useState(false);
    const [tieneAlmacenes, setTieneAlmacenes] = useState(getDataSession('tienda') === 'SHOPIFY');
    const columns = [
        { renderCell: RenderButtons, headerName: '', maxWidth: 20, path: path, opciones: "editar" },
        {
            field: 'id', headerName: 'Id', maxWidth: 20, renderCell: (params) => (
                <a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>)
        },
        {
            field: 'nombre', headerName: 'Nombre', minWidth: 200, renderCell: (params) => (
                <a href={`${path + '/edit/' + params.row.id}`}>{params.value}</a>)
        },
        { field: 'es_Ppal', headerName: 'Es Ppal', flex: 1, type: 'boolean' },
        { field: 'consolidar', headerName: 'Consolidar', flex: 1, type: 'boolean' },
        { field: 'prioridad', headerName: 'Prioridad', flex: 1 },
        { field: 'direccion', headerName: 'Direccion', flex: 1 }
    ];

    function isERP() {
        return erp === 'OKCAR';
    }

    function DescargarAlmacenesERP() {
        Swal.fire({
            text: '¿Desea descargar todos los almacenes de su ERP?',
            showCancelButton: true,
            confirmButtonText: t('app.botones.descargar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(
                `Almacenes/DescargarAlmacenesERP?empresa_id=${getDataSession('empresa')}&sucursal_id=${getDataSession('sucursal')}`,
                null,
                'POST'
            ).then(response => {
                if (response.hasOwnProperty('status') && response.status === 400) {
                    Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                    return;
                } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                    Swal.fire('Error', response.mensajes[0], 'error');
                    return;
                }

                Swal.fire(t('app.Articulos.SwalFire.descargando'), 'Se estan descargando los almacenes. Esto puede tomar un momento', 'info');
                setActualizarTabla(true);
                setActualizarTabla(false);
            });
        });
    }

    function DescargarAlmacenesEcommerce() {
        Swal.fire({
            text: '¿Desea descargar todos los almacenes de su Ecoomerce?',
            showCancelButton: true,
            confirmButtonText: t('app.botones.descargar'),
            cancelButtonText: t('app.botones.cancelar')
        }).then((result) => {
            if (!result.isConfirmed) return;

            fetchConToken(
                `Almacenes/DescargarAlmacenesEcommerce?sucursal_id=${getDataSession('sucursal')}&tienda=${tienda}`,
                null,
                'POST'
            ).then(response => {
                if (response.hasOwnProperty('status') && response.status === 400) {
                    Object.entries(response.errors).map(([key, value]) => Swal.fire('Error', value[0], 'error'));
                    return;
                } else if (response.hasOwnProperty('codigo') && response.codigo !== 200) {
                    Swal.fire('Error', response.mensajes[0], 'error');
                    return;
                }

                Swal.fire(t('app.Articulos.SwalFire.descargando'), 'Se estan descargando los almacenes. Esto puede tomar un momento', 'info');
                setActualizarTabla(true);
                setActualizarTabla(false);
            });
        });
    }

    useEffect(() => {
        setGlobalTitulo(prev => ({
            ...prev,
            titulo: 'Almacenes',
            subtitulo: 'Lista de almacenes por sucursal.'
        }));
        function getConfigERP() {
            fetchConToken(`ConfiguracionesSucursales?sucursal_id=${getDataSession('sucursal')}&nombre=ERP`).then((r) => setERP(r?.valor));
        }
        getConfigERP();
        validarExisteSucursalPrincipal();
        if (getDataSession('tienda') === 'MERCADOLIBRE') fetchConToken(`ConfiguracionesSucursales?sucursal_id=${getDataSession('sucursal')}&nombre=SINC_WAREHOUSE_MANAGEMENT_TO_API`).then((r) => {
            if (r && r.valor) setTieneAlmacenes(r.valor === 'S');
        });
    }, [setGlobalTitulo]);

    return (<>
        <div className='container-fluid'>
            <div className='col-md-12'>
                <div className='col-md-12'>
                    <Link to={`${path}/add`} className='btn btn-outline-primary'>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            fill='currentColor'
                            className='bi bi-plus-square'
                            viewBox='0 0 16 16'
                        >
                            <path d='M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z' />
                            <path d='M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z' />
                        </svg>
                        &nbsp; Nuevo
                    </Link>
                    &nbsp;&nbsp;
                    {isERP() && <button className='btn btn-outline-primary' style={{ width: 'auto' }} onClick={DescargarAlmacenesERP}>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            fill='currentColor'
                            className='bi bi-cloud-arrow-down-fill'
                            viewBox='0 0 16 16'
                        >
                            <path d='M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z' />
                        </svg>&nbsp; Descargar Almacenes
                    </button>}
                    {tieneAlmacenes && <button className='btn btn-outline-primary' style={{ width: 'auto' }} onClick={DescargarAlmacenesEcommerce}>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='20'
                            height='20'
                            fill='currentColor'
                            className='bi bi-cloud-arrow-down-fill'
                            viewBox='0 0 16 16'
                        >
                            <path d='M8 2a5.53 5.53 0 0 0-3.594 1.342c-.766.66-1.321 1.52-1.464 2.383C1.266 6.095 0 7.555 0 9.318 0 11.366 1.708 13 3.781 13h8.906C14.502 13 16 11.57 16 9.773c0-1.636-1.242-2.969-2.834-3.194C12.923 3.999 10.69 2 8 2zm2.354 6.854-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 1 1 .708-.708L7.5 9.293V5.5a.5.5 0 0 1 1 0v3.793l1.146-1.147a.5.5 0 0 1 .708.708z' />
                        </svg>&nbsp; Descargar Almacenes
                    </button>}
                </div>
            </div>
            <div style={{ height: 400, width: '100%' }}>
                <ListTable
                    columns={columns}
                    path={path}
                    reload={actualizarTabla}
                    url={`Almacenes/GetList?sucursal_Id=${getDataSession('sucursal')}`}
                />
            </div>
        </div>
    </>);
};

export { List };